(function ($) {

  if ($('.ns-highchart-graphic').length) {
    $('.ns-highchart-graphic').each(function(){
      var chart = $(this).find('> div > div').attr('id');
      if ($('#' + chart).hasClass('js-chart-loaded')) {
        // console.log('chart already loaded');
      } else {
        setTimeout(function () {
          reflowChart(chart);
        }, 100);
      }
    });
  }

  function makeVisible() {
    $('.fade-in-block, .ns-highchart-graphic').each(function () {
      if ($(this).isInViewport()) {
        $(this).addClass('fade-in-block--visible');
        if ($(this).hasClass('ns-highchart-graphic')) {
            var chart = $(this).find('> div > div').attr('id');
            if ($('#' + chart).hasClass('js-chart-loaded')) {
              // console.log('chart already loaded');
            } else {
              setTimeout(function () {
                reflowChart(chart);
              }, 100);
            }

        }
      }
    });
  }

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };


  function reflowChart(id) {
    $('#' + id).addClass('js-chart-loaded');
    var callback = window.charts[id];
    return callback();
  }

})(jQuery);
